/**
 * Following variables will be used to toggle stuff for sidebar
 */
const sidebar = document.querySelector( '.qala-lms-wrapper.page-with-sidebar' );
const deviceBreakpoint = 992;
const hiddenClass = 'sidebar-collapsed';

if ( sidebar ) {
	const sidebarButton = document.querySelector( '.sidebar-toggle' );

	sidebarButton.addEventListener( 'click', function() {
		if ( window.innerWidth > deviceBreakpoint ) {
			toggleSidebar();
		}
	} );
}

/**
 * Will be toggled on 'sidebar-toggle' button click
 */
function toggleSidebar() {
	sidebar.classList.toggle( hiddenClass );

	// Re-query sidebar, so we make sure we get the latest class list
	const sidebarChange = document.querySelector( '.qala-lms-wrapper.page-with-sidebar' );
	const sidebarClasses = sidebarChange.classList;

	if ( sidebarClasses.contains( hiddenClass ) ) {
		setCookie( hiddenClass, true, 30 );
	} else {
		setCookie( hiddenClass, false, 30 );
	}
}

/**
 * Create a cookie to store the sidebar visibility value
 *
 * @param {string}  name         The name of the cookie.
 * @param {boolean} value        The value to set for it.
 * @param {number}  daysToExpire Number of days before the cookie expires.
 */
function setCookie( name, value, daysToExpire ) {
	const d = new Date();
	d.setTime( d.getTime() + ( daysToExpire * 24 * 60 * 60 * 1000 ) );
	const expires = 'expires=' + d.toUTCString();
	document.cookie = name + '=' + value + ';' + expires + ';path=/';
}

/**
 * Toggle expansion of list on lessons
 */
const buttons = document.querySelectorAll( '.lesson-header--round-button.toggle-button' );
buttons.forEach( function( button ) {
	button.addEventListener( 'click', function() {
		const parent = button.closest( '.lessons-list__lesson-row' );
		parent.classList.toggle( 'lesson-toggled' );
	} );
} );
